<template>
  <div>
    <div align="left">
      <h5 class="h5 mb-3 text-primary font-weight-bold">Event</h5>
    </div>
    <br />
    <b-card class="text-left">
      <h5 class="font-weight-bold text-primary">Create New Event</h5>
      <br />
      <br />
      <b-row>
        <b-col>
          <div>
            <b-tabs content-class="mt-3" justified>
              <b-tab title="Paxelpreneur" active>
                <app-paxelpreneur :totalData="totalData"></app-paxelpreneur>
              </b-tab>
              <b-tab title="Business Consultation">
                <app-business-consultation></app-business-consultation>
              </b-tab>
              <b-tab title="#AntarkanKebaikan">
                <app-Antarkankebaikan></app-Antarkankebaikan>
              </b-tab>
            </b-tabs>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
const Paxelpreneur = () => import("../component/PaxelpreneurCreate");
const BusinessConsultation = () => import('../component/BusinessConsultationCreate');
const Antarkankebaikan = () => import('../component/antarkankebaikanCreate');

export default {
  components: {
    appPaxelpreneur: Paxelpreneur,
    appBusinessConsultation: BusinessConsultation,
    appAntarkankebaikan: Antarkankebaikan,
  },
  data() {
    return {
      totalData:0
    };
  },
  beforeCreate() {
    const vm = this;
    const formData = new FormData();
      formData.append("search_param", "");
      formData.append("limit", 1);
      formData.append("page", 1);
      formData.append("sort_by", "");
      formData.append("is_sort_asc", true);
    this.$store.dispatch("EventModule/getEvent", formData).then(response => {
          vm.totalData = response.data.data.length+1;
        })
        .catch(error => {
        });
  },
  methods: {},
};
</script>

<style scoped>
</style>
